class Logger {
    logEvent(type, eventName) {
        console.info(`%c[${type}]: Event fired ${eventName}`, 'color: #42A5F5');
    }
    log(type, eventName) {
        console.info(`%c[${type}]: ${eventName}`, 'color: #42A5F5');
    }
    performace(message) {
        console.info(`%c[Performance]: ${message}`, 'color: #61d800');
    }
}
export default new Logger();
